/**
 * AI Copilot Service — client for the Radiology Intelligence API.
 */
import apiClient from './apiClient';
import { API_URL } from '../config';

export interface AIQueryContext {
  patient_id?: string;
  study_id?: number;
  session_id?: string;
}

export interface AIQueryRequest {
  query: string;
  context?: AIQueryContext;
  conversation_id?: string;
}

export interface SourceReference {
  source_type: string;
  source_id: string;
  label: string;
  metadata: Record<string, any>;
}

export interface AIQueryResponse {
  answer: string;
  sources: SourceReference[];
  confidence: number;
  intent: string;
  follow_up_suggestions: string[];
  metadata: Record<string, any>;
}

export interface ConversationTurn {
  query: string;
  response: string | null;
  intent: string | null;
  confidence: number | null;
  sources: Record<string, any>[] | null;
  latency_ms: number | null;
  created_at: string;
}

export interface ConversationHistory {
  conversation_id: string;
  turns: ConversationTurn[];
  total: number;
}

const submitQuery = async (request: AIQueryRequest): Promise<AIQueryResponse> => {
  const response = await apiClient.post(`${API_URL}/ai/query`, request);
  return response.data;
};

const getConversationHistory = async (conversationId: string): Promise<ConversationHistory> => {
  const response = await apiClient.get(`${API_URL}/ai/conversations/${conversationId}`);
  return response.data;
};

const bulkIndex = async (): Promise<{ reports: number; transcriptions: number; history_entries: number }> => {
  const response = await apiClient.post(`${API_URL}/ai/index/bulk`);
  return response.data;
};

const aiCopilotService = {
  submitQuery,
  getConversationHistory,
  bulkIndex,
};

export default aiCopilotService;
